import { renderDate } from '../utility/personTabGridHelper';

export const DEFAULT_VALUES = {
  ContactMethodType: '',
  ContactType: '',
  ContactInfo: '',
  IsDefaultContact: false,
  ContactNotes: '',
};

export const CONTACT_GRID_COLUMNS = [
  { field: 'ptsInfoID', headerName: 'Info ID', width: 130 },
  { field: 'ContactMethod', headerName: 'Contact Method', width: 170 },
  { field: 'MethodType', headerName: 'Type', width: 150 },
  { field: 'PartyType', headerName: 'Party Type', width: 150 },
  { field: 'Info', headerName: 'Info', width: 220 },
  { field: 'Created', headerName: 'Created', width: 180, valueFormatter: renderDate },
  { field: 'CreatedBy', headerName: 'Created By', width: 160 },
  { field: 'Updated', headerName: 'Updated', width: 180, valueFormatter: renderDate },
  { field: 'UpdatedBy', headerName: 'Updated By', width: 160 },
];
